import { Popover, css, styled } from '@lux/ds';

export const StyledPopover = styled(Popover)(
  () => css`
    .MuiPaper-root {
      min-width: 255px;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      box-shadow: 2px 2px 14px rgba(19, 17, 19, 0.14);
      transform: translateX(2px) !important;
    }
  `,
);

export const PopoverContent = styled('div')(
  ({ theme }) => css`
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 35px repeat(auto-fill, 28px);
    gap: ${theme.space.s};
    padding: ${theme.space.m} ${theme.space.l};
  `,
);
